export type RoundCtaTarget = {
  label: string;
  href: string;
};

type RoundLike = {
  id: number;
  status: string;
};

/**
 * The viewer shows results, it does not collect them: entering a score happens
 * through the organiser's share link (/scoring/:token), which nobody can reach
 * from a public page. A live round therefore invites looking, not typing — the
 * old "Wpisz wynik" CTA pointed at a screen whose API route never existed.
 */
export function roundCta(round: RoundLike, leagueId: number): RoundCtaTarget {
  const href = `/leagues/${leagueId}/rounds/${round.id}`;

  if (round.status === 'ACTIVE' || round.status === 'CLOSED') {
    return { label: 'Zobacz wyniki →', href };
  }

  if (round.status === 'CANCELLED') {
    return { label: 'Kolejka odwołana', href };
  }

  if (round.status === 'REGISTRATION') {
    return { label: 'Zapisz się →', href };
  }

  return { label: 'Zobacz kolejkę →', href };
}
